const footerMenus = document.querySelectorAll('footer .widgets .widget_nav_menu');

footerMenus.forEach((menu) => {
	const trigger = menu.querySelector('.widget-title');
	const content = menu.querySelector('ul.menu');

	content.classList.add('max-lg:!hidden');

	trigger?.addEventListener('click', () => {
		const opened = !content.classList.contains('max-lg:!hidden');
		content.classList[opened ? 'add' : 'remove']('max-lg:!hidden');
		content.classList[opened ? 'remove' : 'add']('max-lg:!block');
	});
});
